import type { BrandTheme } from '../../src/brands';

/** The brand's colours and fonts as custom properties for engine.css. */
export function themeCss(theme: BrandTheme): string {
  const vars: Record<string, string> = {
    '--ink': theme.ink,
    '--dark': theme.dark,
    '--dark-deep': theme.darkDeep,
    '--primary': theme.primary,
    '--primary-hover': theme.primaryHover,
    '--accent': theme.accent,
    '--accent-dark': theme.accentDark,
    '--on-dark-accent': theme.onDarkAccent,
    '--on-dark-accent-hover': theme.onDarkAccentHover,
    '--ground': theme.ground,
    '--surface': theme.surface,
    '--line': theme.line,
    '--border-input': theme.borderInput,
    '--text-muted': theme.textMuted,
    '--text-soft': theme.textSoft,
    '--tint': theme.tint,
    '--info-bg': theme.infoBg,
    '--info-text': theme.infoText,
    '--font-display': theme.displayFont,
    '--font-body': theme.bodyFont,
  };
  return `:host { ${Object.entries(vars).map(([k, v]) => `${k}: ${v};`).join(' ')} }`;
}

/**
 * Fonts have to be declared in the page itself (a shadow root can't load
 * them), so the brand's Google Fonts and the flag-emoji font for the phone
 * dialling codes are added to the page head once. A page that serves the
 * brand's fonts itself marks a link with data-fonts-included (the
 * stirlingpartners.co.uk pages' site.css), and gets no Google Fonts link.
 */
export function ensureFonts(theme: BrandTheme, engineBase: string): void {
  if (!document.querySelector(`link[data-qe-fonts="${theme.fontsUrl}"], link[data-fonts-included]`)) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = theme.fontsUrl;
    link.dataset.qeFonts = theme.fontsUrl;
    document.head.appendChild(link);
  }
  if (!document.querySelector('style[data-qe-flags]')) {
    const style = document.createElement('style');
    style.dataset.qeFlags = '';
    // Flag artwork: Twemoji by Twitter, CC-BY 4.0, packaged by country-flag-emoji-polyfill (MIT).
    style.textContent = `@font-face { font-family: "Twemoji Country Flags"; src: url("${engineBase}TwemojiCountryFlags.woff2") format("woff2"); unicode-range: U+1F1E6-1F1FF, U+1F3F4, U+E0062-E007F; font-display: swap; }`;
    document.head.appendChild(style);
  }
}
